import { render, staticRenderFns } from "./Tasksoliver.vue?vue&type=template&id=c8a3955e&"
import script from "./Tasksoliver.vue?vue&type=script&lang=js&"
export * from "./Tasksoliver.vue?vue&type=script&lang=js&"
import style0 from "./Tasksoliver.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports